import { render, staticRenderFns } from "./CriterioEvaluacionPage.vue?vue&type=template&id=378e2858"
import script from "./CriterioEvaluacionPage.js?vue&type=script&lang=js&external"
export * from "./CriterioEvaluacionPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports